// "{0}x{1}:{2}x{3}:{4}:{5}", X, Y, Width, Height, RelativeWidthToParent, Angle
export function deserializeBoardTransform(value) {
    if (!value)
        return undefined;

    const values = value.split(':');
    if (values && values.length >= 4)
    {
        const pv = values[0].split('x');
        const sv = values[1].split('x');

        return {
            x: Number.parseFloat(pv[0]),
            y: Number.parseFloat(pv[1]),
            width: Number.parseFloat(sv[0]),
            height: Number.parseFloat(sv[1]),
            relativeWidthToParent: Number.parseFloat(values[2]) 
            //angle: Number.parseFloat(values[3])
        };
    }

    return undefined;
}